import styled from '@emotion/styled';
import { Grid, Paper } from '@material-ui/core';
import { Magnetic } from '@mitchell/react.component.ux';
export const Content = styled('div') `
	text-align: justify;
`;
export const CustomStyleAcknowledgeSection = styled('div') `
	padding: 0 ${Magnetic.spacer24} ${Magnetic.spacer16};
`;
export const CustomStyledActionControlsSection = styled('div', {
    shouldForwardProp: prop => prop !== 'color'
}) `
	padding: 0 ${Magnetic.spacer24} ${Magnetic.spacer12} ${Magnetic.spacer24};
	box-sizing: inherit;

	button,
	button:hover {
		color: ${props => props.color};
	}
`;
export const ActionButtonWrapper = styled('div') `
	display: flex;
	justify-content: center;
`;
export const SmallButton = styled('div') `
	margin: ${Magnetic.spacer06};
	width: 50%;
	text-align: center;
`;
export const LinkContainer = styled('div') `
	display: flex;
	justify-content: center;
	padding: 0 ${Magnetic.spacer24} ${Magnetic.spacer24} ${Magnetic.spacer24};
	box-sizing: inherit;
`;
export const LinkButton = styled('div') `
	margin: ${Magnetic.spacer06};
	width: 50%;
	text-align: center;
	cursor: ${Magnetic.linkBaseCursor};
`;
export const DeclineStyledDiv = styled('div') `
	text-align: center;
	text-decoration: ${Magnetic.annotationBaseTextDecoration};
	margin-bottom: ${Magnetic.spacer16};
	-webkit-tap-highlight-color: transparent;
	font-size: ${Magnetic.baseFontSize};
	color: ${Magnetic.linkFontColor};
	span {
		cursor: ${Magnetic.linkBaseCursor};
	}
`;
export const CarrierSectionContainer = styled('div') `
	margin-bottom: ${Magnetic.spacer08};
`;
export const StyledDivAvatarSpechBoxLayout = styled('div')(`
    padding: ${Magnetic.spacer24};
`);
export const StyledDivTnCContentContainer = styled('div') `
	overflow: auto;
	max-height: calc(100vh - 150px);
`;
export const StyledPreLoadQuestionContent = styled('div')(`
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
`);
export const StyledDivBannerLayout = styled('div')(`
	margin: ${Magnetic.spacer24};
	word-break: break-word;
	#uam-block {
		border-radius : ${Magnetic.whiteLabelMobileSpeechBoxBorderRadius};
	}
`);
export const StyledImage = styled('img')(`
	height: 100px;
	width: 100px;
`);
export const StyledDivDefaultImage = styled(Grid, {
    shouldForwardProp: prop => prop !== 'backgroundImage'
})((props) => `
	background: ${Magnetic[props.backgroundImage]} no-repeat center;
	height: 100px;
	width: 100%;
	background-size: 90px;
	margin-bottom: ${Magnetic.spacer24};
`);
const StyleDivBaseImage = `
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	width: 50px;
	height: 50px;
	outline: none;
	border-radius: 100%;
	border: none;
`;
export const StyledDivCircle = styled('div') `
	${StyleDivBaseImage}
	background-color: ${(props) => props.backgroundColor};
	color: ${Magnetic.colorWhite};
	margin-bottom: ${Magnetic.spacer12};
`;
export const StyledContentPaper = styled(Paper) `
	padding: ${Magnetic.spacer24};
	margin: ${Magnetic.spacer24};
`;
export const StyledCircleSpan = styled('span') `
	position: relative;
	top: ${Magnetic.spacer16};
`;
export const StyledLabelBottom = styled('label') `
	text-align: center;
	display: block;
	color: ${Magnetic.colorBlack};
	margin-bottom: ${Magnetic.spacer20};
	text-transform: none;
`;
export const StyledLabel = styled('label') `
	text-align: center;
	display: block;
	color: ${Magnetic.colorBlack};
	font-weight: ${Magnetic.fontWeightHeavy};
	font-size: ${Magnetic.fontSize16};
	margin-bottom: ${Magnetic.spacer40};
	text-transform: none;
`;
export const StyledGridScriptText = styled(Grid) `
	align-content: center;
	align-items: center;
	text-align: center;
	flex-direction: column;
	padding: 0px 12px;
`;
export const StyledDivContentContainer = styled('div')((props) => `
    background-color: ${props.speechBubbleBackgroundColor};
    text-align: center;
    position: relative; 
    box-shadow: ${Magnetic.boxShadow01};
    padding: ${Magnetic.spacer24};
    border-radius: ${Magnetic.whiteLabelMobileSpeechBoxBorderRadius};
    & div::after {
        content: '';
        position: absolute;
        bottom: 100%;
        width: 0;
        height: 0;
        border-left:${Magnetic.spacer20} ${Magnetic.baseBorderStyle} transparent;
        border-right:${Magnetic.spacer20} ${Magnetic.baseBorderStyle} transparent;
        border-bottom:${Magnetic.spacer20} ${Magnetic.baseBorderStyle} ${props.speechBubbleBackgroundColor};
        left: calc(50% - ${Magnetic.spacer20});
        right: calc(50% - ${Magnetic.spacer20});
      }
      & p {
        text-align: left;
        line-height: ${Magnetic.spacer24}; 
        margin-block-start: 0;
        margin-block-end: 0;
      }
`);
export const StyledIcon = styled('span') `
	padding-left: ${Magnetic.spacer08};
	color: ${(props) => props.color || Magnetic.colorWhite};
	font-size: ${(props) => props.fontSize || Magnetic.baseFontSize};
`;
export const StyledButtonContainer = styled(Grid) `
	margin: 0 ${Magnetic.spacer20} ${Magnetic.spacer06};
`;
export const StyledNavDivContainer = styled.div `
	padding: 0 ${Magnetic.spacer24} ${Magnetic.spacer24} ${Magnetic.spacer24};
`;
export const WarningMessageContent = styled.div `
	white-space: pre-line;
`;
//# sourceMappingURL=IntelligentScriptQuestion.style.js.map